import AppointDistribution from '@/views/product/productGroup/components/AppointDistribution'

const welfareMallMixins = {
  components: {
    AppointDistribution
  },
  data() {
    return {
      openWelfare: false
    }
  },
  methods: {
    getWelfareInfo() { // 获取福利商城信息
      this.getHttpServices().getServerApiService().post('welfareApp/getWelfareInfo', {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      }).then(res => {
        this.openWelfare = res.openWelfare
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    }
  }
}
export default welfareMallMixins
